import { ResolvedDate } from "@models";
import { useStore } from "@stores";
import { salonTime } from "@shared";
import { useEffect } from "react";

interface IProps {
  workerId: string | number | undefined;
  tenantId: string | undefined;
  maxBookingDaysAhead?: number;
  requiredMinutes?: number;
}

interface ResolvedDatesResult {
  resolvedDates: ResolvedDate[];
  loading: boolean;
}

export const useResolvedDates = ({
  workerId,
  tenantId,
  maxBookingDaysAhead,
  requiredMinutes,
}: IProps): ResolvedDatesResult => {
  const { availabilityStore, tenantStore } = useStore();
  const { resolvedDates, loading } = availabilityStore;
  const timeZone = tenantStore.tenant?.timeZone;

  useEffect(() => {
    if (workerId && tenantId) {
      const days =
        maxBookingDaysAhead && maxBookingDaysAhead > 0
          ? maxBookingDaysAhead
          : 365;

      // The range starts on the salon's today — a visitor whose device has already
      // rolled over to tomorrow (or hasn't yet) would otherwise ask for the wrong day.
      const today = salonTime(undefined, timeZone);

      availabilityStore.getResolvedDates({
        userIds: [workerId],
        tenantId,
        from: today.format("YYYY-MM-DD"),
        to: today.add(days, "day").format("YYYY-MM-DD"),
        requiredMinutes,
      });
    }
  }, [
    availabilityStore,
    workerId,
    tenantId,
    maxBookingDaysAhead,
    requiredMinutes,
    timeZone,
  ]);

  return { resolvedDates, loading };
};
